import { PostHogProvider } from "posthog-js/react";
import { ApolloProviderWithAuth0 } from "./ApolloProviderWithAuth0";
import { Auth0WithNavigate } from "./Auth0WithNavigate";
import { StyleRoot } from "@ttc3k/trekker";
import "../styled-system/styles.css";
import "@fontsource-variable/figtree";
import { Outlet } from "react-router-dom";
import { RootLayout } from "shared/components";
import { AppContextProvider } from "AppContext";
import styles from "styled-system/styles.css?inline";
import swiperStyles from "swiper/css?inline";
import swiperScrollbarStyles from "swiper/css/scrollbar?inline";
import customSwiperStyles from "widgets/events/components/EventsCarousel/swiper.css?inline";
import { PostHogAppContext, usePostHog } from "shared/hooks/usePostHog";

export const Root = () => {
  const { posthog, initPostHog, registerPostHog } = usePostHog();

  // Initialize PostHog
  initPostHog("whereabouts-next");

  // Register the appContext property
  registerPostHog({
    appContext: PostHogAppContext.WhereaboutsNext, // This ensures all events from this instance are tagged with `appContext: "whereabouts-next"`
  });

  return (
    <Auth0WithNavigate>
      <ApolloProviderWithAuth0>
        <PostHogProvider client={posthog}>
          <AppContextProvider>
            <StyleRoot
              styles={[
                styles,
                swiperStyles,
                swiperScrollbarStyles,
                customSwiperStyles,
              ]}
            >
              <RootLayout>
                <Outlet />
              </RootLayout>
            </StyleRoot>
          </AppContextProvider>
        </PostHogProvider>
      </ApolloProviderWithAuth0>
    </Auth0WithNavigate>
  );
};
